export const userPermissionContent = {
  app: {
    mom: 'mom-visible',
    pos: 'pos-visible',
    mpos: 'mpos-visible',
    web_dash: 'web-dash-visible',
  },
  module: {
    internal_role: 'internal-role-visible',
    my_restaurant: 'my-restaurant-visible',
    my_account: 'my-account-visible',
    timecards: 'timecards-visible',
    employee_availability: 'employee-availability-visible',
    employee_time_off: 'employee-time-off-visible',
    time_off: 'time-off-visible',
    employees: 'employees-visible',
    roles_permissions: 'roles-permissions-visible',
    orders_payments: 'orders-payments-visible',
    hiring: 'hiring-visible',
    restaurant_configurations: 'restaurant-configurations-visible',
    shift_schedule: 'shift-scheduler-visible',
    shift_pool: 'shift-pool-visible',
    reports: 'reports-visible',
    menu_reports: 'menu-reports-visible',
    clock_in: 'clock-in-visible',
    table_layout: 'table-layout-visible',
    menu: 'menu-visible',
    payments: 'payments-visible',
    ticket: 'ticket-visible',
    header: 'header-visible',
    dashboard: 'dashboard-visible',
    cashdrawer: 'cashdrawer-visible',
    login: 'login-visible',
    restaurant_location: 'restaurant-&-location-visible',
    menu_manager: 'menu-manager-visible',
    marketing: 'marketing-visible',
    website: 'website-visible',
    integrations: 'integrations-visible',
    orders_payment: 'orders-payments-visible',
    settings: 'settings-visible',
    move_item: 'move-item-visible',

    // Tips Manager
    tips_management: 'tips-management-visible',

    //MoM Further Modules
    employee_management: 'employee-management-visible',
    employee_payroll: 'employee-payroll-visible',
    lost_and_found: 'lost-&-found-visible',
    doc_vault: 'docvault-visible',
    task_manager: 'task-manager-visible',
    aiocare: 'aio-care-visible',
    pay_management: 'pay-management-visible',

    web_payroll: 'payroll-visible',

    // Inventory in MoM
    wastage_logs: 'inventory-wastage-logs-visible',
    placed_orders: 'inventory-placed-orders-visible',
    inventory_variance: 'inventory-variance-visible',
    prepare_prep_list: 'inventory-prepare-prep-list-visible',
    cook_prep_list: 'inventory-cook-prep-list-visible',

    // Inventory
    inventory: 'inventory-visible',

    //Modules not in the DB
    employee_payout: 'employee-payout-visible',
    accounting: 'accounting-visible',

    //Nugget-Configuration
    nugget: 'nugget-visible',
    adjust: 'adjust-visible',
    tenders: 'tenders-visible',
    order_hub: 'order-hub-visible',

    // Aio assistance
    aio_assistance: 'aio-assistance-visible',
    notifications: 'notifications-visible',
    generalSettingNotifications: 'general-setting-notifications-visible',

    menu_board_visible: 'menu-board-visible',
    catering: 'catering-visible',
  },

  // For the feature, we are using the key in place of the feature endpoint i.e menu/list = menu_list: "menu-read" and if there is any dash sign '-' or slash '/' in endpoint replace with underscore as well '_'
  feature: {
    //for internal users these key doesn't exist in DB and we are using these keys for super admin
    aiobuddy_list: 'aiobuddy-read',
    aiobuddy_create: 'aiobuddy-create',
    aiobuddy_update: 'aiobuddy-edit',
    aiobuddy_delete: 'aiobuddy-delete',

    operations_list: ' operations-read',
    operations_create: ' operations-create',
    operations_update: ' operations-edit',
    operations_delete: ' operations-delete',

    business_list: 'restaurant-read',
    business_create: 'restaurant-create',
    business_update: 'restaurant-edit',
    business_delete: 'restaurant-delete',
    restaurant_list: 'location-read',
    restaurant_create: 'location-create',
    restaurant_update: 'location-edit',
    restaurant_delete: 'location-delete',
    menu_list: 'menu-read',
    menu_create: 'menu-create',
    menu_update: 'menu-edit',
    menu_delete: 'menu-delete',
    category_list: 'category-read',
    category_create: 'category-create',
    category_update: 'category-edit',
    category_delete: 'category-delete',
    item_list: 'Item-read',
    item_create: 'Item-create',
    item_update: 'Item-edit',
    item_delete: 'Item-delete',
    tags_allergens_getdata: 'tags-&-allergens-read',
    tags_allergens_create: 'tags-&-allergens-create',
    tags_allergens_delete: 'tags-&-allergens-delete',
    modifier_list: 'modifier-read',
    modifier_create: 'modifier-create',
    modifier_update: 'modifier-edit',
    modifier_delete: 'modifier-delete',
    modifier_group_list: 'modifier-group-read',
    modifier_group_create: 'modifier-group-create',
    modifier_group_update: 'modifier-group-edit',
    modifier_group_delete: 'modifier-group-delete',
    modifier_option_list: 'modifier-option-read',
    modifier_option_create: 'modifier-option-create',
    modifier_option_update: 'modifier-option-edit',
    modifier_option_delete: 'modifier-option-delete',

    tips_sharing: 'tips-sharing-read',
    tips_pooling_list: 'tips-pooling-read',
    tips_pooling_create: 'tips-pooling-create',
    tips_pooling_update: 'tips-pooling-edit',
    tips_pooling_delete: 'tips-pooling-delete',
    tips_pooling_visible: 'tips-pooling-visible',

    comp_list: 'comps-read',
    comp_create: 'comps-create',
    comp_update: 'comps-edit',
    comp_delete: 'comps-delete',
    service_charge_list: 'service-charge-read',
    service_charge_create: 'service-charge-create',
    service_charge_update: 'service-charge-edit',
    service_charge_delete: 'service-charge-delete',
    sales_tax_list: 'sales-tax-read',
    sales_tax_create: 'sales-tax-create',
    sales_tax_update: 'sales-tax-edit',
    sales_tax_delete: 'sales-tax-delete',
    user_operation_list: 'operation-read',
    user_operation_create: 'operation-create',
    user_operation_update: 'operation-edit',
    user_operation_delete: 'operation-delete',
    user_aio_buddy_list: 'aio-buddy-read',
    user_aio_buddy_create: 'aio-buddy-create',
    user_aio_buddy_update: 'aio-buddy-edit',
    user_aio_buddy_delete: 'aio-buddy-delete',
    brandbook_create: 'brandbook-create',
    website_builder_read: 'website-builder-read',
    website_templates_read: 'website-templates-read',
    website_seo_read: 'website-seo-read',
    website_overview_read: 'overview-read',
    website_forms_read: 'forms-read',
    website_announcements_read: 'website-announcements-read',
    tenders_list: 'tenders-read',
    tenders_create: 'tenders-create',
    tenders_update: 'tenders-edit',
    tenders_delete: 'tenders-delete',
    payments_ticketId_read: 'update-visible',
    payments_cardpaymenttrigger_ticketId_create: 'update-visible',
    payments_cardrefundtrigger_ticketId_create: 'refund-visible',
    payments_refund_ticketId_create: 'refund-visible',
    payments_ticketId_create: 'update-visible',
    payments_cartId_create: 'update-visible',
    payments_refund_ticketId_read: 'refund-visible',
    payments_stripe_refund_paymentId_read: 'refund-visible',
    payments_tip_ticketId_update: 'update-visible',
    cash_drawer_adjust_balance_posId_update: 'adjust-starting-balance-visible',
    cash_drawer_drawerlogs_posId_create: 'logs-visible',
    cash_drawer_closelogs_posId_create: 'close-drawer-visible',
    cash_drawer_all_cash_drawerId_read: 'my-station-visible',
    cash_drawer_cash_payment_logs_create: 'logs-visible',
    cash_drawer_users_cashDrawerId_read: 'my-station-visible',
    cash_drawer_all_restaurantId_read: 'my-station-visible',
    table_floor_create: 'table-visible',
    table_bulk_table_floorId_update: 'table-visible',
    table_floor_floorId_delete: 'table-visible',
    table_tableId_delete: 'table-visible',
    table_my_table_read: 'table-visible',
    table_floors_and_tables_read: 'table-visible',
    table_tables_statuses_restaurantId: 'table-visible',
    table_ticket_tableId_read: 'table-visible',
    table_floor_restaurant_restaurantId_read: 'table-visible',
    table_floor_floorId_read: 'table-visible',
    table_restaurantId_read: 'table-visible',
    table_me_assign_table_update: 'table-visible',
    table_check_table_number_restaurantId_tableNo_read: 'table-visible',
    table_tableNo_restaurant_read: 'table-visible',
    table_all_tables_restaurantId_read: 'table-status-visible',
    ticket_service_charges_ticketId_update: 'service-charges-visible',
    ticket_read: 'change-server-visible',
    ticket_ticketdata_ticketId_update: 'change-server-visible',
    ticket_ticketId_read: 'change-server-visible',
    ticket_update_ticketId_update: 'change-server-visible',
    ticket_update_status_ticketId_update: 'change-server-visible',
    ticket_split_ticketId_update: 'change-server-visible',
    ticket_split_by_order_orderId_update: 'change-server-visible',
    ticket_ticketId_delete: 'void-order-visible',
    ticket_items_ticketId_delete: 'custom-item-visible',
    ticket_voidorder_update: 'void-order-visible',
    pos_dashboard_z_report_read: 'z-report-visible',
    pos_dashboard_my_day_create: 'my-day-visible',
    pos_dashboard_server_checkout_read: 'employee-attendance-visible',
    pos_dashboard_overview_create: 'overview-visible',
    cash_drawer_list: 'cash-drawer-read',
    cash_drawer_create: 'cash-drawer-create',
    cash_drawer_update: 'cash-drawer-edit',
    cash_drawer_delete: 'cash-drawer-delete',
    close_out_visible: 'closeout-visible',

    my_account_list: 'my-account-read',
    my_account_visible: 'my-account-visible',
    my_account_create: 'my-account-create',
    my_account_update: 'my-account-edit',
    my_account_delete: 'my-account-delete',

    employee_timeLog_clock_in_create: 'clock-in-visible',
    employee_timeLog_clock_out_create: 'clock-in-visible',
    employee_timeLog_break_in_create: 'clock-in-visible',
    employee_timeLog_break_out_create: 'clock-in-visible',
    employee_timeLog_force_break_out_create: 'clock-in-visible',
    view_order_details: 'view-order-details-visible',

    pos_pin_visible: 'pos-pin-visible',

    // marketing
    dashboard: 'dashboard-read',
    overview_read: 'overview-read',
    brandbook: 'brandbook-read',
    guestbook: 'guestbook-read',
    guest_spend: 'guest-spend-read',
    guest_segments: 'guest-segments-read',
    deal: 'deals-read',
    deal_create: 'deals-create',
    deals_visible: 'deals-visible',
    deals_read: 'deals-read',
    spotlight: 'spotlights-read',
    spotlight_create: 'spotlights-create',
    campaign: 'campaigns-read',
    campaign_create: 'campaigns-create',
    campaign_edit: 'campaigns-edit',
    loyalty: 'loyalty-read',
    loyalty_visible: 'loyalty-visible',
    loyalty_read: 'loyalty-read',
    review_management: 'review-management-read',
    review_management_update: 'review-management-edit',
    journey: 'journeys-read',
    journey_create: 'journeys-create',
    journey_update: 'journeys-edit',
    loyalty_create: 'loyalty-create',
    loyalty_update: 'loyalty-edit',
    gift_card: 'gift-cards-read',
    gift_card_create: 'gift-cards-create',
    gift_card_update: 'gift-cards-edit',
    gift_card_visible: 'gift-cards-visible',
    gift_card_read: 'gift-cards-read',
    roles_permission_list: 'roles-permissions-read',
    roles_permission_update: 'roles-permissions-edit',
    roles_permission_create: 'roles-permissions-create',

    //MoM
    restaurant_chats: 'p2p-chat-visible',
    campaign_approve_button: 'approve-button-visible',

    //Nugget-Configuration Features
    nugget_configuration_list: 'nugget-configuration-read',
    nugget_configuration_create: 'nugget-configuration-create',
    nugget_configuration_update: 'nugget-configuration-edit',
    nugget_configuration_delete: 'nugget-configuration-delete',

    featured_menu_list: 'featured-menu-read',
    featured_menu_create: 'featured-menu-create',
    featured_menu_update: 'featured-menu-edit',
    featured_menu_delete: 'featured-menu-delete',

    featured_ads_list: 'featured-ads-read',
    featured_ads_create: 'featured-ads-create',
    featured_ads_update: 'featured-ads-edit',
    featured_ads_delete: 'featured-ads-delete',
    //Shift Scheduler
    shifts_create: 'shifts-create',
    shifts_edit: 'shifts-edit',
    shifts_read: 'shifts-read',
    shifts_visible: 'shifts-visible',
    shifts_delete: 'shifts-delete',
    employee_shift_ownshift: 'own-shifts-visible',
    employee_shift_duplicate: 'duplicate-shift-button-visible',
    employee_shift_assign_to_another: 'assign-to-another-employee-button-visible',
    release_shifts_visible: 'release-shifts-visible',
    release_other_shifts_visible: 'release-other-employees-shift-visible',
    bid_open_shifts_visible: 'bid-on-open-shifts-visible',

    shift_pool: {
      pool_read: 'pool-read',
      pool_visible: 'pool-visible',
      pool_edit: 'pool-edit',
      approve_requests_visible: 'approve-requests-visible',
      release_manager_approval_required: 'release-manager-approval-required-visible',
    },

    mom_dashboard: {
      overview_read: 'overview-read',
      staff_read: 'staff-read',
      office_read: 'office-read',
      marketing_read: 'marketing-read',
    },
    timecard: {
      export_timecards_read: 'export-timecards-read',
      view_own_timecards_visible: 'view-own-timecards-visible',
      view_own_timecards_read: 'view-own-timecards-read',
      edit_time_entries_visible: 'edit-time-entries-visible',
      edit_time_entries_read: 'edit-time-entries-read',
      edit_time_entries_edit: 'edit-time-entries-edit',
      auto_time_off_notification_visible: 'auto-time-off-notification-visible',
    },

    //Employee Management
    employee_details_button: 'details-button-visible',
    employee_resend_invite: 'resend-invite-visible',
    employees_create: 'employees-create',
    employees_edit: 'employees-edit',
    employees_delete: 'employees-delete',
    employees_list: 'employees-read',
    deactivate_employee_visible: 'deactivate-employee-visible',
    re_activate_employee_visible: 're-activate-employee-visible',
    personal_information_visible: 'personal-information-visible',
    personal_information_read: 'personal-information-read',
    personal_information_edit: 'personal-information-edit',
    assigned_roles_visible: 'assigned-roles-visible',
    assigned_roles_read: 'assigned-roles-read',
    assigned_roles_create: 'assigned-roles-create',
    assigned_roles_edit: 'assigned-roles-edit',
    assigned_roles_delete: 'assigned-roles-delete',
    location_level_access_visible: 'location-level-access-visible',
    location_level_access_create: 'location-level-access-create',
    location_level_access_edit: 'location-level-access-edit',
    location_level_access_delete: 'location-level-access-delete',
    documents_visible: 'documents-visible',

    //Restaurant Configuration
    general_settings_visible: 'general-settings-visible',
    general_settings_edit: 'general-settings-edit',
    device_settings_edit: 'device-settings-edit',
    device_settings_visible: 'device-settings-visible',
    online_ordersing_edit: 'online-ordersing-edit',
    online_ordersing_visible: 'online-ordersing-visible',

    //My Restaurant
    business_information_visible: 'business-information-visible',
    business_information_read: 'business-information-read',
    business_information_edit: 'business-information-edit',
    restaurant_information_edit: 'restaurant-information-edit',
    restaurant_information_read: 'restaurant-information-read',
    restaurant_information_visible: 'restaurant-information-visible',
    bank_accounts_edit: 'bank-accounts-edit',

    //Availability
    availability_visible: 'availability-visible',
    availability_delete: 'availability-delete',
    availability_create: 'availability-create',
    availability_edit: 'availability-edit',
    availability_read: 'availability-read',
    view_other_employees_visible: 'view-other-employees-visible',
    view_other_employees_read: 'view-other-employees-read',

    //Reports
    net_sales_visible: 'net-sales-visible',
    net_sales_read: 'net-sales-read',
    net_sales_edit: 'net-sales-edit',
    net_sales_create: 'net-sales-create',
    net_sales_delete: 'net-sales-delete',

    sales_summary_visible: 'sales-summary-visible',
    sales_summary_create: 'sales-summary-create',
    sales_summary_delete: 'sales-summary-delete',
    sales_summary_edit: 'sales-summary-edit',
    sales_summary_read: 'sales-summary-read',

    timecards_visible: 'timecards-visible',
    timecards_create: 'timecards-create',
    timecards_delete: 'timecards-delete',
    timecards_edit: 'timecards-edit',
    timecards_read: 'timecards-read',

    payroll_history_visible: 'payroll-history-visible',
    payroll_history_create: 'payroll-history-create',
    payroll_history_delete: 'payroll-history-delete',
    payroll_history_edit: 'payroll-history-edit',
    payroll_history_read: 'payroll-history-read',

    payroll_summary_report_visible: 'payroll-summary-report-visible',
    payroll_summary_report_read: 'payroll-summary-report-read',

    performance_summary_report_visible: 'performance-summary-report-visible',
    performance_summary_report_create: 'performance-summary-report-create',
    performance_summary_report_delete: 'performance-summary-report-delete',
    performance_summary_report_edit: 'performance-summary-report-edit',
    performance_summary_report_read: 'performance-summary-report-read',

    third_party_order_report_visible: 'third-party-order-report-visible',
    third_party_order_report_create: 'third-party-order-report-create',
    third_party_order_report_delete: 'third-party-order-report-delete',
    third_party_order_report_edit: 'third-party-order-report-edit',
    third_party_order_report_read: 'third-party-order-report-read',

    discount_report_visible: 'discount-report-visible',
    discount_report_create: 'discount-report-create',
    discount_report_delete: 'discount-report-delete',
    discount_report_edit: 'discount-report-edit',
    discount_report_read: 'discount-report-read',

    merchant_report_visible: 'merchant-report-visible',
    merchant_report_create: 'merchant-report-create',
    merchant_report_edit: 'merchant-report-edit',
    merchant_report_read: 'merchant-report-read',
    merchant_report_delete: 'merchant-report-delete',

    labor_cost_visible: 'labor-cost-visible',
    labor_cost_read: 'labor-cost-read',
    overtime_visible: 'overtime-visible',
    overtime_read: 'overtime-read',
    employee_productivity_visible: 'employee-productivity-visible',
    employee_productivity_read: 'employee-productivity-read',
    break_compliance_visible: 'break-compliance-visible',
    break_compliance_read: 'break-compliance-read',
    // Tips Pooling Report (Reports Module - featureId 226)
    // Note: These are unique keys for Reports module, separate from Tips Management module (featureId 169)
    tips_pooling_report_visible: 'tip-pooling-report-visible',
    tips_pooling_report_read: 'tip-pooling-report-read',
    // Legacy: kept for backward compatibility with old migrations
    // This was previously used for Reports but now maps to Tips Management only
    tips_pooling_read: 'tips-pooling-read',

    menu_summary_visible: 'menu-summary-visible',
    menu_summary_read: 'menu-summary-read',

    // Temporarily hidden - Marketing Reports (2026)
    // // Marketing Reports (separate from marketing module)
    deals_report_visible: 'deals-report-visible',
    deals_report_read: 'deals-report-read',
    deals_report_edit: 'deals-report-edit',
    deals_report_delete: 'deals-report-delete',
    gift_card_report_visible: 'gift-card-report-visible',
    gift_card_report_read: 'gift-card-report-read',
    gift_card_report_edit: 'gift-card-report-edit',
    gift_card_report_delete: 'gift-card-report-delete',
    // loyalty_report_visible: 'loyalty-report-visible',
    // loyalty_report_read: 'loyalty-report-read',

    labour_cost_visible: 'labour-cost-visible',
    comps_voids_visible: 'comps-voids-visible',
    top_sellers_visible: 'top-sellers-visible',
    break_violations_visible: 'break-violations-visible',

    //Lost & Found
    mark_as_retrieved_visible: 'mark-as-retrieved-visible',
    lost_items_edit: 'lost-items-edit',
    lost_items_read: 'lost-items-read',
    lost_items_create: 'lost-items-create',
    lost_items_delete: 'lost-items-delete',
    lost_items_visible: 'lost-items-visible',
    found_items_visible: 'found-items-visible',
    found_items_read: 'found-items-read',
    found_items_edit: 'found-items-edit',
    found_items_create: 'found-items-create',
    found_items_delete: 'found-items-delete',

    //Doc & Vault
    custom_category_create: 'custom-category-create',
    custom_category_edit: 'custom-category-edit',
    custom_category_delete: 'custom-category-delete',
    custom_category_visible: 'custom-category-visible',
    files_create: 'files-create',
    files_delete: 'files-delete',
    files_edit: 'files-edit',
    folders_create: 'folders-create',
    folders_delete: 'folders-delete',
    folders_edit: 'folders-edit',

    //Task Manager
    tasks_create: 'tasks-create',
    tasks_visible: 'tasks-visible',
    tasks_read: 'tasks-read',
    tasks_edit: 'tasks-edit',
    tasks_delete: 'tasks-delete',
    re_assign_visible: 're-assign-visible',
    can_be_assigned_a_task_visible: 'can-be-assigned-a-task-visible',

    //Time Off
    time_off_request_visible: 'time-off-request-visible',
    time_off_request_create: 'time-off-request-create',
    time_off_request_read: 'time-off-request-read',
    time_off_request_edit: 'time-off-request-edit',
    time_off_request_delete: 'time-off-request-delete',
    approve_requests_visible: 'approve-requests-visible',
    request_tab_visible: 'request-tab-visible',
    processed_tab_visible: 'processed-tab-visible',
    my_own_tab_visible: 'my-own-tab-visible',
    time_off_policy_visible: 'time-off-policy-visible',
    time_off_policy_create: 'time-off-policy-create',
    time_off_policy_read: 'time-off-policy-read',
    time_off_policy_edit: 'time-off-policy-edit',
    time_off_allocation_visible: 'time-off-allocation-visible',
    time_off_allocation_create: 'time-off-allocation-create',
    time_off_allocation_read: 'time-off-allocation-read',
    time_off_allocation_edit: 'time-off-allocation-edit',
    time_off_leave_overview_visible: 'time-off-leave-overview-visible',
    time_off_leave_overview_create: 'time-off-leave-overview-create',
    time_off_leave_overview_read: 'time-off-leave-overview-read',
    time_off_leave_overview_edit: 'time-off-leave-overview-edit',
    employee_time_off_requests_visible: 'time-off-requests-visible',
    employee_time_off_requests_create: 'time-off-requests-create',
    employee_time_off_requests_read: 'time-off-requests-read',
    employee_time_off_requests_edit: 'time-off-requests-edit',
    time_off_settings_visible: 'time-off-settings-visible',
    time_off_settings_create: 'time-off-settings-create',
    time_off_settings_read: 'time-off-settings-read',
    time_off_settings_edit: 'time-off-settings-edit',

    //Payroll
    pay_schedules_visible: 'pay-schedules-visible',
    pay_schedules_create: 'pay-schedules-create',
    pay_schedules_edit: 'pay-schedules-edit',

    payroll_create: 'payroll-create',
    payroll_edit: 'payroll-edit',
    paper_check_read: 'paper-check-read',

    onboarding_visible: 'onboarding-visible',
    onboarding_read: 'onboarding-read',
    onboarding_create: 'onboarding-create',
    setup_payroll_read: 'setup-read',
    setup_payroll_visible: 'setup-visible',
    filing_preparation_visible: 'filing-preparation-visible',
    benefits_visible: 'benefits-visible',
    benefits_read: 'benefits-read',
    benefits_create: 'benefits-create',
    benefits_update: 'benefits-update',
    benefits_delete: 'benefits-delete',

    //Orders & Payment
    refund_visible: 'refund-visible',
    move_payment_visible: 'move-payment-visible',

    //Dashboard
    overview_visible: 'overview-visible',
    staff_visible: 'staff-visible',
    office_visible: 'office-visible',
    marketing_visible: 'marketing-visible',
    your_week_visible: 'your-week-visible',
    your_week_read: 'your-week-read',
    inventory_overview_visible: 'inventory-overview-visible',
    aio_care_chat_overview_visible: 'aio-care-chat-overview-visible',

    // Inventory
    ingredients_list: 'ingredients-read',
    ingredients_create: 'ingredients-create',
    ingredients_update: 'ingredients-edit',
    ingredients_delete: 'ingredients-delete',
    ingredients_visible: 'ingredients-visible',
    orders_list: 'orders-read',
    orders_create: 'orders-create',
    orders_update: 'orders-edit',
    orders_delete: 'orders-delete',
    recipes_list: 'recipes-read',
    recipes_create: 'recipes-create',
    recipes_update: 'recipes-edit',
    recipes_delete: 'recipes-delete',
    invoices_list: 'invoices-read',
    invoices_create: 'invoices-create',
    invoices_update: 'invoices-edit',
    invoices_delete: 'invoices-delete',
    storage_areas_list: 'storage-areas-read',
    storage_areas_create: 'storage-areas-create',
    storage_areas_update: 'storage-areas-edit',
    storage_areas_delete: 'storage-areas-delete',
    vendors_list: 'vendors-read',
    vendors_create: 'vendors-create',
    vendors_update: 'vendors-edit',
    vendors_delete: 'vendors-delete',
    non_ingredients_list: 'non-ingredients-read',
    non_ingredients_create: 'non-ingredients-create',
    non_ingredients_update: 'non-ingredients-edit',
    non_ingredients_delete: 'non-ingredients-delete',
    change_server: 'change-server-visible',
    main_recipe_list: 'recipes-visible',
    // accounting
    chart_of_accounts_create: 'chart-of-accounts-create',
    chart_of_accounts_list: 'chart-of-accounts-read',
    chart_of_accounts_edit: 'chart-of-accounts-edit',
    chart_of_accounts_delete: 'chart-of-accounts-delete',
    bill_payments_create: 'bill-payments-create',
    bill_payments_list: 'bill-payments-read',
    bill_payments_edit: 'bill-payments-edit',
    bill_payments_delete: 'bill-payments-delete',
    journal_entry_create: 'journal-entry-create',
    journal_entry_list: 'journal-entry-read',
    journal_entry_edit: 'journal-entry-edit',
    journal_entry_delete: 'journal-entry-delete',
    reconciliation_create: 'reconciliation-create',
    reconciliation_read: 'reconciliation-read',
    reconciliation_edit: 'reconciliation-edit',
    reconciliation_delete: 'reconciliation-delete',
    sales_controller_create: 'sales-controller-create',
    sales_controller_read: 'sales-controller-read',
    sales_controller_edit: 'sales-controller-edit',
    sales_controller_delete: 'sales-controller-delete',
    financial_statement_visible: 'financial-statement-visible',
    financial_statement_create: 'financial-statement-create',
    financial_statement_read: 'financial-statement-read',
    financial_statement_edit: 'financial-statement-edit',
    financial_statement_delete: 'financial-statement-delete',

    // Inventory in MoM
    wastage_logs: 'inventory-wastage-logs-visible',
    placed_orders: 'inventory-placed-orders-visible',
    inventory_variance: 'inventory-variance-visible',
    prepare_prep_list: 'inventory-prepare-prep-list-visible',
    cook_prep_list: 'inventory-cook-prep-list-visible',

    employee_payout: 'employee-payout-visible',

    //settings
    receipt_settings_list: 'receipt-settings-read',
    receipt_settings_create: 'receipt-settings-create',
    receipt_settings_update: 'receipt-settings-edit',
    receipt_settings_delete: 'receipt-settings-delete',
    // Mom Pay Management
    pay_management: {
      own_pay_stubs: 'view-own-paystubs-visible',
      others_pay_stubs: 'view-others-pay-stubs-visible',
    },

    business_hours_list: 'business-hours-read',
    business_hours_create: 'business-hours-create',
    business_hours_edit: 'business-hours-edit',
    business_hours_delete: 'business-hours-delete',

    pos_visible: 'pos-visible',
    pos_create: 'pos-create',
    pos_list: 'pos-read',
    pos_edit: 'pos-edit',
    pos_delete: 'pos-delete',
    // Aio assistance
    aio_assistance: 'aio-assistance-visible',
    generalSettingNotifications: 'general-setting-notifications-visible',

    //reports
    reports_visible: 'reports-visible',
    reports_create: 'reports-create',
    reports_read: 'reports-read',
    refund_report_visible: 'refund-report-visible',
    refund_report_create: 'refund-report-create',
    refund_report_edit: 'refund-report-edit',
    refund_report_read: 'refund-report-read',
    refund_report_delete: 'refund-report-delete',
    reports_edit: 'reports-edit',
    reports_delete: 'reports-delete',

    playlists_visible: 'playlists-visible',
    playlists_create: 'playlists-create',
    playlists_delete: 'playlists-delete',
    playlists_edit: 'playlists-edit',
    playlists_read: 'playlists-read',
    screens_visible: 'screens-visible',
    screens_create: 'screens-create',
    screens_delete: 'screens-delete',
    screens_edit: 'screens-edit',
    screens_read: 'screens-read',
    catering: {
      dashboard_visible: 'dashboard-visible',
      dashboard_create: 'dashboard-create',
      dashboard_delete: 'dashboard-delete',
      dashboard_edit: 'dashboard-edit',
      dashboard_read: 'dashboard-read',

      package_configuration_visible: 'package-configuration-visible',
      package_configuration_create: 'package-configuration-create',
      package_configuration_delete: 'package-configuration-delete',
      package_configuration_edit: 'package-configuration-edit',
      package_configuration_read: 'package-configuration-read',

      email_templates_visible: 'email-templates-visible',
      email_templates_create: 'email-templates-create',
      email_templates_delete: 'email-templates-delete',
      email_templates_edit: 'email-templates-edit',
      email_templates_read: 'email-templates-read',

      invoice_management_visible: 'invoice-management-visible',
      invoice_management_create: 'invoice-management-create',
      invoice_management_delete: 'invoice-management-delete',
      invoice_management_edit: 'invoice-management-edit',
      invoice_management_read: 'invoice-management-read',

      payment_configuration_visible: 'payment-configuration-visible',
      payment_configuration_create: 'payment-configuration-create',
      payment_configuration_delete: 'payment-configuration-delete',
      payment_configuration_edit: 'payment-configuration-edit',
      payment_configuration_read: 'payment-configuration-read',

      calendar_visible: 'calendar-visible',
      calendar_create: 'calendar-create',
      calendar_delete: 'calendar-delete',
      calendar_edit: 'calendar-edit',
      calendar_read: 'calendar-read',

      email_inbox_visible: 'email-inbox-visible',
      email_inbox_read: 'email-inbox-read',
      email_inbox_delete: 'email-inbox-delete',
      email_inbox_edit: 'email-inbox-edit',
      email_inbox_create: 'email-inbox-create',
    },

    move_item_visible: 'move-item-visible',
  },
} as const;
